const MINUTES_PER_DAY = 24 * 60;

export const BOT_AGENTS: string[] = [
  'googlebot',
  'bot',
  'Googlebot-Mobile',
  'Googlebot-Image',
  'Google favicon',
  'Mediapartners-Google',
  'bingbot',
  'slurp',
  'java',
  'wget',
  'curl',
  'bot',
  'datadog',
  'nginx',
  'kube',
  'Go-http-client',
  'Iframely',
  'chrome-lighthouse',
  'health-check',
  'lighthouse',
];

export const DEFAULT_COOKIE_EXPIRATION_IN_DAYS = 90;
export const DEFAULT_COOKIE_EXPIRATION_IN_MIN = DEFAULT_COOKIE_EXPIRATION_IN_DAYS * MINUTES_PER_DAY;
export const GROUP_ID_TYPE_MAP = {
  A: 'accountantLead',
  C: 'company',
  L: 'companyLead',
};
export const LONG_TERM_COOKIE_EXPIRATION_IN_MIN = 20 * 365 * MINUTES_PER_DAY;
export const VISITOR_COOKIE_NAME = 'visitor_id';
export const SESSION_COOKIE_NAME = 'gsid';
export const SESSION_START_NEEDED_COOKIE_NAME = 'session_start_needed';
export const VISITOR_ID_ORIGIN_HASH_COOKIE_NAME = 'visitor_id_origin_h';
export const TRACKING_COOKIE_PREFIX = 'gst_';
export const AD_FRAUD_COOKIE_NAME = 'gafd_id';
export const AD_FRAUD_ORIGIN_HASH_COOKIE_NAME = 'gafd_id_origin_h';
export const EXPERIMENT_COOKIE_NAME = 'gexp_id';
export const EXPERIMENT_ORIGIN_HASH_COOKIE_NAME = 'gexp_id_origin_h';
export const USER_PROFILE_SERVICE_COOKIE_NAME = 'ups_id';
export const USER_PROFILE_SERVICE_ORIGIN_HASH_COOKIE_NAME = 'ups_id_origin_h';
export const USER_TARGETING_COOKIE_NAME = 'user_target_id';
export const USER_TARGETING_ORIGIN_HASH_COOKIE_NAME = 'user_target_id_origin_h';
export const UNWANTED_FULLSTORY_TRACK_CALL_PROPERTIES = [
  'gusto_analytics_version',
  'gafd_id',
  'gexp_id',
  'has_signed_in',
  'is_bot',
  'optanon_consent',
  'page_view_id',
  'ups_id',
  'userId',
  'user_id',
  'user_role_id',
  'user_target_id',
  'visitorId',
];

// This exists because by default, we didn't want to send all .track calls to
// Intercom. They have a limit of 120 unique event names, after which events
// have to be archived to make room for more.
export const DEFAULT_OMITTED_TRACKING_PROVIDERS: any[] = [];

export const SCROLL_PERCENTAGES: number[] = [25, 50, 75, 100];

export const ONETRUST_COOKIE_NAME: string = 'OptanonConsent';

export const FIRST_SESSION_COOKIE_NAME: string = 'fgsid';
